class LightboxGallery {
    constructor() {
        this.contentContainer = document.querySelector('.article-template__content');
        this.lightbox = document.querySelector('.lightbox');
        this.openLightboxButton = document.querySelector('#open-lightbox-btn'); // Get the button

        if (!this.contentContainer || !this.lightbox) return;

        this.lightboxImage = this.lightbox.querySelector('.lightbox-image');
        this.closeButton = this.lightbox.querySelector('.lightbox-close');
        this.prevButton = this.lightbox.querySelector('.lightbox-prev');
        this.nextButton = this.lightbox.querySelector('.lightbox-next');

        this.updateImagesList();
        
        this.openLightbox = this.openLightbox.bind(this);
        this.closeLightbox = this.closeLightbox.bind(this);
        this.nextImage = this.nextImage.bind(this);
        this.prevImage = this.prevImage.bind(this);
        this.handleKeyboard = this.handleKeyboard.bind(this);
        this.updateImagesList = this.updateImagesList.bind(this);
        this.openFirstImage = this.openFirstImage.bind(this); // Bind the new method

        this.initializeEvents();
    }

    updateImagesList() {
        this.images = Array.from(this.contentContainer.querySelectorAll('img:not(.lightbox-image)'));
        this.currentImageIndex = 0;
    }

    initializeEvents() {
        this.contentContainer.addEventListener('click', (e) => {
            const clickedImage = e.target.closest('img');
            if (clickedImage && !clickedImage.classList.contains('lightbox-image')) {
                const index = this.images.indexOf(clickedImage);
                if (index !== -1) {
                    this.openLightbox(index);
                }
            }
        });

        if (this.openLightboxButton) {
            this.openLightboxButton.addEventListener('click', this.openFirstImage);
        }

        this.closeButton.addEventListener('click', this.closeLightbox);
        this.prevButton.addEventListener('click', this.prevImage);
        this.nextButton.addEventListener('click', this.nextImage);
        document.addEventListener('keydown', this.handleKeyboard);
    }

    openFirstImage() {
        if (this.images.length > 0) {
            this.openLightbox(0);
        }
    }

    openLightbox(index) {
        this.currentImageIndex = index;
        this.lightboxImage.src = this.images[index].src;
        this.lightboxImage.alt = this.images[index].alt;
        this.lightbox.classList.add('active');

        if (this.images.length <= 1) {
            this.lightbox.classList.add('single-image');
        } else {
            this.lightbox.classList.remove('single-image');
        }

        document.body.style.overflow = 'hidden';
    }

    closeLightbox() {
        this.lightbox.classList.remove('active');
        document.body.style.overflow = '';
    }

    nextImage() {
        this.currentImageIndex = (this.currentImageIndex + 1) % this.images.length;
        this.lightboxImage.src = this.images[this.currentImageIndex].src;
        this.lightboxImage.alt = this.images[this.currentImageIndex].alt;
    }

    prevImage() {
        this.currentImageIndex = (this.currentImageIndex - 1 + this.images.length) % this.images.length;
        this.lightboxImage.src = this.images[this.currentImageIndex].src;
        this.lightboxImage.alt = this.images[this.currentImageIndex].alt;
    }

    handleKeyboard(event) {
        if (!this.lightbox.classList.contains('active')) return;

        switch(event.key) {
            case 'Escape':
                this.closeLightbox();
                break;
            case 'ArrowLeft':
                this.prevImage();
                break;
            case 'ArrowRight':
                this.nextImage();
                break;
        }
    }
}

// Initialize after DOM content is loaded
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLightbox);
} else {
    initLightbox();
}

function initLightbox() {
    new LightboxGallery();
}
